import { DashboardShell } from "../components/dashboard/DashboardKit";
import { Home, Settings, FolderOpen, ClipboardList, Calendar, MessageSquare } from "lucide-react";


const adminNav = [
{ icon: <Home className="w-5 h-5" />, label: "Dashboard", path: "/admin-dashboard" },
  
  {
    icon: <Settings className="w-5 h-5" />,
    label: "Masters",
    children: [
      { label: "User Master",  path: "/user-master"  },
      
      { label: "Phase Master", path: "/phase-master" },
      { label: "Task Master",  path: "/task-master"  },
      {label: "Report Master", path:"/report-category-master"},
      {label: "Segment Master", path:"/discussion-topic-master"},
      {label: "Mail Logs", path:"/mail-logs"}
    ],
  },
    {
    icon: <FolderOpen className="w-5 h-5" />,
    label: "Project Management",
    children: [
      { label: "Project List",      path: "/project-list"      },
      { label: "Project Add",       path: "/project-add"       },
      { label: "Project Approvals", path: "/project-approvals" },
      { label: "Reassign Projects", path: "/reassign-project"  },
    ],
  },
  {
    icon: <ClipboardList className="w-5 h-5" />,
    label: "Reports & Approvals",
    children: [
      { label: "Project Reports", path: "/project-reports" },
      { label: "Report Approval", path: "/report-approval" },
      { label: "Deleted Reports", path: "/deleted-reports" },
    ],
  },
  {
    icon: <MessageSquare className="w-5 h-5" />,
    label: "Client Feedback",
    path: "/feedback-log",
  },
  {
    icon: <Calendar className="w-5 h-5" />,
    label: "Planning",
    children: [{ label: "Work Schedule", path: "/work-schedule" }],
  },
 
];

const adminStats = [
  { label: "Projects", value: "07", className: "text-ap-violetLight" },
  { label: "Users",    value: "15", className: "text-ap-green"       },
  { label: "Reports",  value: "12", className: "text-ap-red"         },
];

function AdminLayout({ children }) {
  const userName     = localStorage.getItem("name") || "Admin";
  const userInitials = userName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  return (
    <>
    <style>{`@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap'); * { font-family: 'Montserrat', sans-serif !important; }`}</style>
    <DashboardShell
      portal="Admin Portal"
      roleLabel="ADMIN"
      title="Admin Workspace"
      subtitle="Monitor projects, teams, approvals and overall performance"
      navItems={adminNav}
      stats={adminStats}
      user={{ initials: userInitials, name: userName, role: "Super Administrator" }}
    >
      {children}
  </DashboardShell>
    </>
  );
}

export default AdminLayout;